import styled from '@emotion/styled'

export const StyleHeading = styled.h1<any>`
  font-size: 24px;
  color: ${(props: any) => props.theme.colors[props?.tc]};
  font-weight: 400;
`
